<template>
  <div>
    <hr class="u-mrgn-top--4">
    <div class="u-txt--medium u-mrgn-top--4">
      Baca Juga:
      <ul class="u-txt--base c-list-ui c-list-ui--link c-list-ui--grouped">
        <li class="c-list-ui__item" v-for="(link, index) in otherLinks" :key="index">
          <a class="u-fg--red-brand" :href="link.link_url" data-no-turbolink="true">{{ link.link_title }}</a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OtherLinkFooter',
  props: {
    otherLinks: {
      type: Array,
      default: () => [],
    }
  }
}
</script>

<style scoped>
ul {
  column-count:3;
}
hr {
  border-color: #e5e5e5
}
</style>
